import {
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";
import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Login from "./pages/login/login";
import Dashboard from "./pages/Dashboard/dashboard";
import Expo from "./pages/Expo/expo";
// import ExpoLot from "./pages/ExpoLot/expoLot";
import Member from "./pages/Member/member";
import Lot from "./pages/Lot/lot";
import Product from "./pages/Product/product";
import MemberPayslip from "./pages/MemberPayslip/memberPayslip";
import MainLayout from "./components/Layout/MainLayout";
import Account from "./pages/Account/account";
import Setting from "./pages/Setting/setting";
import "./App.css";
import MemberReport from "./pages/Report/MemberList/memberList";
import ProductReport from "./pages/Report/ProductList/productList";
import ExpoLotReport from "./pages/Report/ExpoLotReport/expoLotReport";
import LotReport from "./pages/Report/LotReport/LotReport";
import api from "./api/api";
import apiUtil from "./api/apiUtil";
import getToken from "./pages/getToken";
import PermissionMessage from "./components/PermissionMessage/PermissionMessage";
import Loading from "./components/Loading/Loading";
import { message } from "antd";
import authStore from "./store/authStore";

function App() {
  const auth = authStore(state => state.auth);
  const moduleList = authStore(state => state.moduleList);
  const setModuleList = authStore(state => state.setModuleList);
  const clearAuthData = authStore(state => state.clearAuthData);

  const isAuthenticated = !!auth;
  const navigate = useNavigate();

  const getAdminInfo = () => {

    if (!auth) return;

    const param = {
      userId: auth.userId,
      brandId: auth.brandId,
    };

    api.get("Admin/GetAdminInfo", param, getToken()).then((result) =>
      apiUtil.parseResult(
        result,
        (response) => {
          if (response.data.code === 401) {
            message.warning(response.data.message);
            clearAuthData();
            window.location.href = "/login";
          } else if (response.data.code === 200) {
            setModuleList(response.data.data.adminModules);
            handleRedirection(response.data.data.adminModules);
          } else {
            message.error(response.data.message);
          }
        },
        (error) => {
          console.log(error);
        }
      )
    );
  };

  const handleRedirection = (moduleList) => {
    for (const action of moduleActions) {
      const module = moduleList.find(
        (module) => module.name === action.name && module.accessLevel === 4
      );
      if (module) {
        if (action.route) navigate(action.route);
        return;
      }
    }
  };

  const moduleActions = [
    { name: "Dashboard", route: "/dashboard" },
    { name: "Member", route: "/member" },
    { name: "Product", route: "/product" },
    { name: "Notification", route: "/notification" },
    { name: "Report", route: "/report/add" },
  ];

  useEffect(() => {
    if (auth) {
      getAdminInfo();
    }
  }, [auth]);

  return (
    <Routes>
      <Route
        index
        exact
        path="/"
        element={
          isAuthenticated ? (
            moduleList.length > 0 ? (
              <Navigate replace to="/dashboard" />
            ) : (
              <Loading />
            )
          ) : (
            <Navigate replace to="/login" />
          )
        }
        className="loginForm"
      ></Route>
      <Route exact path="/login" element={<Login />}></Route>
      <Route
        exact
        path="/dashboard"
        element={
          moduleList.some(
            (module) => module.name === "Dashboard" && module.accessLevel === 4
          ) ? (
            <MainLayout>
              <Dashboard />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="dashboard" />
              </MainLayout>
            </>
          )
        }
      ></Route>
      <Route
        exact
        path="/expo"
        element={
          moduleList.some(
            (module) => module.name === "Expo" && module.accessLevel === 4
          ) ? (
            <MainLayout>
              <Expo />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="expo" />
              </MainLayout>
            </>
          )
        }
      ></Route>
      {/* <Route
        exact
        path="/expolot"
        element={
          moduleList.some(
            (module) => module.name === "Expo" && module.accessLevel === 4
          ) ? (
            <MainLayout>
              <ExpoLot />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="expoLot" />
              </MainLayout>
            </>
          )
        }
      ></Route> */}
      <Route
        exact
        path="/member"
        element={
          moduleList.some(
            (module) => module.name === "Member" && module.accessLevel === 4
          ) ? (
            <MainLayout>
              <Member />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="member" />
              </MainLayout>
            </>
          )
        }
      ></Route>
      <Route
        exact
        path="/lot"
        element={
          moduleList.some(
            (module) => module.name === "Lot" && module.accessLevel === 4
          ) ? (
            <MainLayout>
              <Lot />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="lot" />
              </MainLayout>
            </>
          )
        }
      ></Route>
      <Route
        exact
        path="/product"
        element={
          moduleList.some(
            (module) => module.name === "Product" && module.accessLevel === 4
          ) ? (
            <MainLayout>
              <Product />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="product" />
              </MainLayout>
            </>
          )
        }
      ></Route>
      <Route
        exact
        path="/payslip"
        element={
          moduleList.some(
            (module) => module.name === "Payslip" && module.accessLevel === 4
          ) ? (
            <MainLayout>
              <MemberPayslip />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="payslip" />
              </MainLayout>
            </>
          )
        }
      ></Route>
      <Route
        exact
        path="/profile-settings"
        element={
          <MainLayout>
            <Setting />
          </MainLayout>
        }
      ></Route>
      <Route
        exact
        path="/account"
        element={
          <MainLayout>
            <Account />
          </MainLayout>
        }
      ></Route>
      <Route
        exact
        path="/report/member-report"
        element={
          moduleList.some(
            (module) => module.name === "Report" && module.accessLevel === 4
          ) ? (
            <MainLayout>
              <MemberReport />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="report" />
              </MainLayout>
            </>
          )
        }
      ></Route>
      <Route
        exact
        path="/report/product-report"
        element={
          moduleList.some(
            (module) => module.name === "Report" && module.accessLevel === 4
          ) ? (
            <MainLayout>
              <ProductReport />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="report" />
              </MainLayout>
            </>
          )
        }
      ></Route>
      <Route
        exact
        path="/report/expolot-report"
        element={
          moduleList.some(
            (module) => module.name === "Report" && module.accessLevel === 4
          ) ? (
            <MainLayout>
              <ExpoLotReport />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="report" />
              </MainLayout>
            </>
          )
        }
      ></Route>
       <Route
        exact
        path="/report/lot-report"
        element={
          moduleList.some(
            (module) => module.name === "Report" && module.accessLevel === 4
          ) ? (
            <MainLayout>
              <LotReport />
            </MainLayout>
          ) : (
            <>
              <Loading />
              <MainLayout>
                <PermissionMessage page="report" />
              </MainLayout>
            </>
          )
        }
      ></Route>
    </Routes>
  );
}
export default App;
